import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M16.5 21.513a1.5 1.5 0 0 1-1.9 1.446L4.1 20.042A1.5 1.5 0 0 1 3 18.6V2.487a1.5 1.5 0 0 1 1.9-1.446l10.5 3.391a1.5 1.5 0 0 1 1.1 1.445Z"
    }, null, -1),
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4.5.987h15a1.5 1.5 0 0 1 1.5 1.5v15.75a1.5 1.5 0 0 1-1.5 1.5h-3"
    }, null, -1)
  ]));
}
const interfaceContentBookPage = { render };
export {
  interfaceContentBookPage as default,
  render
};
//# sourceMappingURL=interface-content-book-page.svg.js.map
